/**
 * Firebase e-mailverificatie (verzenden en user reload).
 */
import { sendEmailVerification, reload } from 'firebase/auth';
import { auth } from '@/lib/firebase';

const PASSWORD_PROVIDER_ID = 'password';

/**
 * @param {import('firebase/auth').User | null | undefined} user
 * @returns {boolean}
 */
export const isPasswordAuthUser = (user) => {
  if (!user || user.isAnonymous) {
    return false;
  }
  return user.providerData?.some((p) => p.providerId === PASSWORD_PROVIDER_ID) ?? false;
};

/**
 * @param {import('firebase/auth').User | null | undefined} user
 */
export const sendUserEmailVerification = async (user) => {
  if (!user) {
    const err = new Error('No authenticated user');
    err.code = 'auth/no-user';
    throw err;
  }
  await sendEmailVerification(user);
};

/**
 * @returns {Promise<import('firebase/auth').User | null>}
 */
export const reloadCurrentUser = async () => {
  const user = auth.currentUser;
  if (!user) {
    return null;
  }
  await reload(user);
  return auth.currentUser;
};
